import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { PublicIpService } from '../public-ip.service';

@Injectable()
export class ClientIpInterceptor implements HttpInterceptor {
  // Only these services receive the headers. Before adding a service here,
  // make sure its CORS config allows X-Client-Public-IP and
  // X-Client-Location, otherwise every request to it will fail at the
  // preflight stage.
  private readonly targetApiUrls: string[] = [
    environment.stpOperationApiUrl,
    environment.baseApiUrl, // ACL service
    environment.tamApiUrl,
    environment.appealApiUrl, // appeal service (CORS updated in SimpleCrosFilter)
    environment.researchAndStudiesApiUrl, // research & studies (CORS updated in SimpleCrosFilter)
    environment.stpRegistrationApiUrl, // stp registration (CORS updated in SimpleCrosFilter)
  ];

  constructor(private publicIpService: PublicIpService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const publicIp = this.publicIpService.getPublicIp();
    const location = this.publicIpService.getLocation();

    if (publicIp && this.targetApiUrls.some((url) => req.url.startsWith(url))) {
      const headers: { [name: string]: string } = {
        'X-Client-Public-IP': publicIp,
      };
      if (location) {
        // HTTP header values must be ISO-8859-1 safe; city names may not be,
        // so the value is URL-encoded here and decoded by the backend
        // (AuditContextResolver).
        headers['X-Client-Location'] = encodeURIComponent(location);
      }
      req = req.clone({ setHeaders: headers });
    }

    return next.handle(req);
  }
}
